<div class="boxes">
  <div>
    <div>{{ 'manage-recovery-payment-recovered' | translate }}</div>
    <div class="amount">
      <div>{{ invoicedAmount }}</div>
      <div class="greyed">{{ currency }}</div>
    </div>
  </div>
</div>
